import React from 'react';

import TripAnomaliesMap from './TripAnomaliesMap';
import TripAnomalyDetails from './TripAnomalyDetails';

const TripComparisonSection = ({
  hasTripData,
  hasAdjustmentData,
  tripData,
  distanceAndCoordinatesAdjustment,
  tripAnomalyDetailsQuery,
  journeyTimestamps,
  t,
  onMapClick,
}) => {
  if (!hasTripData && !hasAdjustmentData) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        gap: '20px',
        width: 'fit-content',
        marginBottom: '32px',
        justifyContent: 'space-between',
      }}
    >
      {hasTripData && (
        <div style={{ flex: 1 }}>
          <TripAnomalyDetails
            created={tripAnomalyDetailsQuery.data.created}
            distance={tripData.journeyDistance}
            journeyStartTs={tripData.journeyStartTs}
            journeyEndTs={tripData.journeyEndTs}
            title={t('recordedTrip')}
            tripId={tripData?.radarInformations?.tripId}
            t={t}
          />
          <TripAnomaliesMap
            t={t}
            journeyGeoJson={tripData.journeyGeoJson}
            onViewFullScreenClick={onMapClick}
            tripType="recorded"
          />
        </div>
      )}
      {hasAdjustmentData && (
        <div style={{ flex: 1 }}>
          <TripAnomalyDetails
            distance={distanceAndCoordinatesAdjustment.distance}
            journeyStartTs={journeyTimestamps.startTs}
            journeyEndTs={journeyTimestamps.endTs}
            title={t('adjustedTrip')}
            isRecordedTrip={false}
            t={t}
          />
          <TripAnomaliesMap
            t={t}
            journeyGeoJson={distanceAndCoordinatesAdjustment.journeyGeoJson}
            onViewFullScreenClick={onMapClick}
            lineColor="#ff8c42"
            tripType="adjusted"
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(TripComparisonSection);
